import { render, staticRenderFns } from "./mailings-stats-general-table.vue?vue&type=template&id=5d472359&"
import script from "./mailings-stats-general-table.vue?vue&type=script&lang=js&"
export * from "./mailings-stats-general-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports